import {Input, Component, forwardRef, OnInit, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl } from '@angular/forms';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, Observable, Observer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {TipoTipologica} from "../../../models/tipologiche/tipo-tipologica";
declare var $: any;

export const RADIO_BUTTON_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioButtonComponent),
  multi: true
};

@Component({
  selector: '[radioButtonInput]',
  templateUrl: 'radio-button.component.html',
  styleUrls: ['./radio-button.component.css'],
  providers: [RADIO_BUTTON_VALUE_ACCESSOR, NgbTooltipConfig]
})
export class RadioButtonComponent implements ControlValueAccessor, OnInit, OnChanges {
  nameFormInput: string;
  groupLabelId = 'radioGroupLabel_' + Math.random().toString(36).substring(2, 9);
  groupHelpId = 'radioGroupHelp_' + Math.random().toString(36).substring(2, 9);
  @Input() edit: boolean;
  @Input() radioButtonOptions: any;
  @Input() control: AbstractControl;
  @Input() checkedRadioId: string;
  @Input() nameRadio: string;
  @Input() submitPending: boolean;
  @Input() classCol: string;
  @Output() onReturn = new EventEmitter();
  @Input() statoEntitaTemplate: boolean;
  @Input() statoTemplateTitle: string;
  @Input() mandatory: boolean = true;
  private onTouchedCallback: () => void = () => { };
  private onChangeCallback: (_: any) => void = () => { };
  private optionCallback: any;
  private _value: any;
  public enableObservable: Observable < boolean > ;
  private subscription: Subscription = null;
  private enableObserver: Observer < boolean > ;
  randomId: string = this.getRandomId();

  constructor(private httpService: HttpClient) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.edit) {
      this.nameFormInput = this.edit ? 'mod' : '';
    }
  }

  private createServiceSubscription() {
    this.enableObservable = new Observable < boolean > (observer => {
      this.enableObserver = observer;
      if (this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
    }

    if (!this.classCol) {
      this.classCol = 'col-sm-4';
    }
  }

  isChecked(elementId: string) {
    if (elementId === this.checkedRadioId) {
      return true;
    } else {
      return false;
    }
  }

  onChange(optionRadio: any): any {
    this.onReturn.emit(JSON.parse(JSON.stringify(optionRadio)));
  }

  writeValue(value: any): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  getRandomId(length: number = 10): string {
    return crypto.randomUUID();
  }
}
